import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiGetPersonnes } from "../../../api/ApiPersonnes";
import { apiGetStatistiques } from "../../../api/ApiTracking";

const BlocEpingleStats = () => {
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  //const [personnesEmail, setPersonnesEmail] = useState([]);
  //const [nbrVisitesUniques, SetNbrVisitesUniques] = useState(0);
  const [pourcentageVisites, setPourcentageVisites] = useState(false);

  const recupPersonnes = async () => {
    /* calcul du nbr de personnes dans les entreprises principales (ou sur tout le groupe si pas de principales)  */
    const resPersonnes = await apiGetPersonnes(ReduxInstance._id, "include=marque");
    let personnes = [];
    let personnesEmail = [];
    let personnesFrequentation = [];
    let NbrVisitesUniques = [];

    if (resPersonnes) {
      const personnesDansOrganisationsPrincipales = resPersonnes.data.filter(
        (item) => item.marque && item.marque.pinned === true
      );

      // si on a des personnes en retour cela signifie qu'il y a vait au moins 1 orga principale
      if (personnesDansOrganisationsPrincipales.length > 0) {
        personnes = [...personnesDansOrganisationsPrincipales];
      }
      // sinon on conserve toutes les pesonnes
      else {
        personnes = [...resPersonnes.data];
      }

      personnes.map((personne, index) => personnesEmail.push(personne.email));
    }

    /* calcul du nolbre de visites sur cette instance au cours des 4 dernières semaines */
    var date = new Date();
    date.setDate(date.getDate() - 28);
    var dateCalculee =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 < 10 ? "0" : "") +
      (date.getMonth() + 1) +
      "-" +
      (date.getDate() < 10 ? "0" : "") +
      date.getDate();

    const resStats = await apiGetStatistiques(
      ReduxInstance._id,
      "filter[createdAt][$gte]=" + dateCalculee
    );
    if (resStats) {
      resStats.data.map((tracking, index) => personnesFrequentation.push(tracking.email));
      personnesFrequentation = personnesFrequentation.filter((x, i, a) => a.indexOf(x) === i);
    }

    /*  maintenant on va regarder si il y a une correspondance entre les personnes declarées sur easyGOUV et les gens qui sont passés ces derniers mois */
    personnesFrequentation.map((tracking, index) => {
      if (personnesEmail.includes(tracking)) {
        NbrVisitesUniques++;
      }
      return "";
    });

    calculPourcentage(NbrVisitesUniques, personnesEmail.length);
  };

  const calculPourcentage = (nbrVisitesUniques, nbrCollaborateurs) => {
    let pourcentage = 0;
    if (nbrCollaborateurs > 0) {
      pourcentage = Math.round((nbrVisitesUniques / nbrCollaborateurs) * 100);
      setPourcentageVisites(pourcentage + "%");
    }
  };

  useEffect(() => {
    recupPersonnes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="text-center pt-2">
      {pourcentageVisites ? (
        <div className="hackHomeEthicsTransparent">
          Vous êtes {pourcentageVisites} à visiter régulièrement cet espace
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default BlocEpingleStats;
